/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Download_TitleInputs */

const en_home_download_title = /** @type {(inputs: Home_Download_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download CADCraft for free`)
};

/**
* | output |
* | --- |
* | "Download CADCraft for free" |
*
* @param {Home_Download_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_download_title = /** @type {((inputs?: Home_Download_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Download_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_download_title(inputs)
});
export { home_download_title as "home.download.title" }